import { trackEvent } from '../../analytics/consent';

const CHANNEL_NAME = 'CacheInvalidationChannel';

const isSubscribed = (cable, userId) => {
  const subs = cable?.subscriptions?.subscriptions || [];
  return subs.some((s) => {
    try {
      const id = JSON.parse(s.identifier);
      return id.channel === CHANNEL_NAME && id.user_id === userId;
    } catch {
      return false;
    }
  });
};

const cacheInvalidationChannel = (cable, userId, handlers = {}) => {
  if (!cable || typeof cable?.subscriptions?.create !== 'function') return null;
  if (!userId) return null;
  if (isSubscribed(cable, userId)) return null;

  try {
    return cable.subscriptions.create(
      { channel: CHANNEL_NAME, user_id: userId },
      {
        connected: () => handlers.onConnected?.(),
        disconnected: () => {
          trackEvent('realtime_disconnected', { reason: 'cache_invalidation_channel' });
          handlers.onDisconnected?.();
        },
        received: (payload) => {
          const data = typeof payload === 'string' ? JSON.parse(payload) : payload;
          // TEMP: trace cache invalidation traffic during verification
          try {
            console.info('[cache-channel] received', data);
          } catch {}
          handlers.onReceive?.(data);
        },
      },
    );
  } catch (error) {
    console.warn('[Cable] CacheInvalidation subscription failed', error);
    return null;
  }
};

export default cacheInvalidationChannel;
